import http from "@/util/http";
import "Base64";
import JsEncrypt from "jsencrypt/bin/jsencrypt.min.js";

class LoginApi {
  static accessSca(data) {
    return http.get("/sca/authority/createToken", data);
  }
  // 通过系统token换取oatoken
  getCbdToken(data) {
    let url = "/share-foreign/flow/getCBDTokenByShareToken";
    return http.post(url, data);
  }
  //登录
  login(params, appId) {
    let user = {};
    user.account = params.username;
    let base64pwd = btoa(params.password);
    let encrypt = new JsEncrypt();
    //设置RES公钥
    encrypt.setPublicKey(process.env.PUBLICKEY);
    //密码RSA加密
    user.password = encrypt.encrypt(base64pwd);
    user.appId = appId;
    user.specialType = params.specialType;
    user.smsCode = params.smsCode;
    var url = "/share-system/system/sca/validatePassword";
    return http.get(url, user);
  }

  //获取验证码
  sendMessage(params) {
    var url = "/share-system/system/sca/sendMessage";
    return http.get(url, params);
  }

  //短信验证码校验
  validateCode(params) {
    var url = "/share-system/system/sca/validateCode";
    return http.get(url, params);
  }

  //重置密码
  resetPassword(params) {
    let data = {};
    data.account = params.account;
    data.appId = params.appId;
    let oldBase64pwd = btoa(params.oldPassword);
    let newBase64pwd = btoa(params.newPassword);
    let encrypt = new JsEncrypt();
    //设置RES公钥
    encrypt.setPublicKey(process.env.PUBLICKEY);
    //密码RSA加密
    data.oldPassword = encrypt.encrypt(oldBase64pwd);
    data.newPassword = encrypt.encrypt(newBase64pwd);
    var url = "/share-system/system/sca/resetPassword";
    return http.post(url, data);
  }
  // 获取通知
  getNotify() {
    let url = "/share-foreign/homePage/getOpenWindowMsg";
    return http.post(url, {});
  }
  getMenu(params) {
    var url = "/share-system/menu/getLeftMenuList";
    return http.post(url, params);
  }

  getUserInfo() {
    // var url = '/share-system/userinfo/detail';
    // return http.post(url, params);
    // todo 获取用户信息接口
    return Promise.reject();
  }
  getInfo() {
    return http.get("/aaas-auth/getInfo");
  }

  logout(params) {
    var url = "/authAction/shareLogout";
    return http.post(url, params);
  }

  //  获取应用列表
  access(params) {
    var url = "/share-system/app/access";
    return http.post(url, params);
  }

  // 获取当前用户权限列表
  getPermission(params) {
    var url = "/share-system/role/getAllResPermissions";
    return http.post(url, params);
  }

  //修改主题颜色配置
  savePeopleColor(params) {
    var url = "/share-legal/people/color/savePeopleColor";
    return http.post(url, params);
  }

  //获取当前登录人的主题颜色
  getColor(params) {
    var url = "/share-legal/people/color/getColor";
    return http.post(url, params);
  }
  // 新的单点登录，换成了post
  static exchangeToken(data) {
    return http.post("/ibs/replaceToken", data);
  }
  static loginSso(data) {
    return http.post("/ibs/loginNew", data);
  }

  //账号是否需要验证码登录
  isOpenSmsCodeVerifyByAccount(params) {
    var url = "/share-system/system/sca/isOpenSmsCodeVerifyByAccount";
    return http.get(url, params);
  }
  //点击获取验证码
  getSmsCode(params) {
    var url = "/share-system/system/sca/sendSmsCodeByAccount";
    return http.get(url, params);
  }
}

export default LoginApi;
